const $ = window.jQuery;

import 'slick-carousel';
import _ from 'lodash';

$(() => {
    const $galleries = $('.bleeding-gallery');

    if (!$galleries.length) {
        return;
    }

    _.each($galleries, gallery => {
        const $gallery = $(gallery);
        const instance = $gallery.attr('data-instance');
        const $modal = $(`#bleeding-gallery-modal-${instance}`);
        const $overlay = $(`#bleeding-gallery-overlay-${instance}`);
        const $close = $gallery
            .find('.bleeding-gallery__modal-close-button')
            .first();
        const $featured = $gallery.find('.bleeding-gallery__feat');
        const $current = $(`#bleeding-gallery-current-slide-${instance}`);
        const $arrows = $gallery.find('.bleeding-gallery__modal-images-arrows');
        const $desc_slider = $gallery
            .find('.bleeding-gallery__modal-desc-slider')
            .first();
        const $image_slider = $gallery
            .find('.bleeding-gallery__modal-images-slider')
            .first();
        const $caption_slider = $gallery
            .find('.bleeding-gallery__modal-caption-slider')
            .first();
        const $expand = $gallery
            .find('.bleeding-gallery__modal-bottom-expand')
            .first();

        $desc_slider.slick({
            arrows: false,
            fade: true,
        });

        $image_slider.slick({
            appendArrows: $arrows,
            fade: true,
            prevArrow: `<button class="slick-prev bleeding-gallery__button"><i class="icon-arrow-min-left"></i><span class="bleeding-gallery__button-text">Previous Slide</span></button>`,
            nextArrow: `<button class="slick-next bleeding-gallery__button"><i class="icon-arrow-min-right"></i><span class="bleeding-gallery__button-text">Next Slide</span></button>`,
        });

        $caption_slider.slick({
            arrows: false,
            fade: true,
        });

        _.each([$desc_slider, $image_slider, $caption_slider], slider => {
            const $slider = $(slider);
            $slider.on('beforeChange', function(
                event,
                slick,
                currentSlide,
                nextSlide,
            ) {
                $current.html(nextSlide + 1);
                _.each(
                    [$desc_slider, $image_slider, $caption_slider],
                    slider => {
                        if (!$slider.is(slider)) {
                            $(slider).slick('slickGoTo', nextSlide);
                        }
                    },
                );
            });
        });

        $expand.on('click', function() {
            $(this)
                .parent()
                .scrollTop(0);
            $(this)
                .parent()
                .toggleClass('bleeding-gallery__modal-bottom--active');
        });

        $featured.on('click', function() {
            $overlay
                .addClass('bleeding-gallery__overlay--active animated fadeIn')
                .one('animationend', function() {
                    $(this).removeClass('animated fadeIn');
                });
            $modal
                .addClass(
                    'bleeding-gallery__modal--active animated fadeInUpBig',
                )
                .one('animationend', function() {
                    $(this).removeClass('animated fadeInUpBig');
                });
        });

        $close.on('click', function() {
            $overlay
                .addClass('animated fadeOut')
                .one('animationend', function() {
                    $(this).removeClass(
                        'animated fadeOut bleeding-gallery__overlay--active',
                    );
                });
            $modal
                .addClass('animated fadeOutDownBig')
                .one('animationend', function() {
                    $(this).removeClass(
                        'bleeding-gallery__modal--active animated fadeOutDownBig',
                    );
                });
        });
    });
});
